document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('a');

  links.forEach(link => {
    try {
      const url = new URL(link.href, window.location.href);

      if (url.hostname !== 'cmecourses.healthstream.com' && url.hostname !== window.location.hostname) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (e) {
      console.warn(`Invalid URL for link: ${link.href}`, e);
    }
  });
});